import {
  UPDATE_UH_COMPONENT_SHOWING_NOW,
  UPDATE_HEADER_RELOAD_AND_BACK,
  UPDATE_CONTENT_SUGG_USER_INPUT,
  TOGGLE_USER_INPUT,
  TOGGLE_MAIN_WINDOW_AND_FAB,
  UPDATE_SKILLS_RESPONSE,
  UPDATE_EXCEPTION_MSG,
  UPDATE_RESOLVED_SUPP_SKILL,
  TOGGLE_AVA_LOADING,
  SHOW_AVA_MODAL,
  CLOSE_AVA_MODAL,
  UPDATE_SELECTED_PRODUCT,
  UPDATE_SELECTED_VERSION,
  UPDATE_SHOW_PRODUCT_PICKER,
  DISABLE_NAVBAR,
  SHOW_FAIL_SCREEN,
  TOGGLE_POP_UP_MAIN_WINDOW,
  OPEN_UHM_THROUGH_LINK,
  UPDATE_CONTEXTUAL_LINK_ORIGIN,
  UPDATE_LINK_LOCATION,
  UPDATE_CONTACT_APP_LOADING,
  QUICK_TOGGLE_SHOW_PHONE_FOOTER,
  UPDATE_CONTENT_SUGG_LOADING,
  SHOW_FEEDBACK_WIDGET_FLOW,
  FEEDBACK_WIDGET_MOUNTED,
  HIDE_SECONDARY_NAV,
  SHOW_CONFIRM_MODAL,
  SHOW_ADDITIONAL_QUESTIONS,
  UPDATE_UI_DATA,
  RESET_UI_STATES,
  RESET_TO_HOME,
  CONTAINER_EVENT_MESSAGE,
  UPDATE_FAB_HEADER_COLORS,
  UPDATE_IS_CHAT_ACTIVE,
  IS_END_CHAT_THROUGH_BUTTON,
  UPDATE_UHM_SUB_HEADER_TYPE,
  UPDATE_SAVE_CHAT_TRIGGER,
  UPDATE_END_CHAT_TRIGGER,
  UPDATE_SHOW_OVERLAY_COMPONENT,
  HAS_INTRUCTIONAL_TEXT,
  UPDATE_USER_INPUT_FROM_AVA,
  ANYTHING_ELSE_END_CHAT,
  // SHOW_AGENT_AVAILABILITY_COMPONENT,
  SHOW_AGENT_AVAILABILITY_FALLBACK_COMPONENT,
  SHOW_ANYTHING_ELSE_COMPONENT,
  SHOW_PHONE_HOUR_BUBBLE_COMPONENT,
  DEEPLINK_CA_EDU_FLOW,
  UPDATE_USER_INTERACTION,
  UPDATE_OPEN_AFTER_REDIRECT,
  UPDATE_REQUEST_ID
} from './types';

export const updateUHComponentShowingNow = (id, actionData = {}) => {
  return {
    type: UPDATE_UH_COMPONENT_SHOWING_NOW,
    payload: {id, actionData},
  };
};

export const updateHeaderReloadAndBack = (showOrHide) => {
  return {
    type: UPDATE_HEADER_RELOAD_AND_BACK,
    payload: showOrHide,
  };
};

export const updateHideSecondaryNav = (isHide, modalityShowing = '') => {
  return {
    type: HIDE_SECONDARY_NAV,
    payload: {isHide, modalityShowing},
  };
};

export const updateShowModal = (
  isShow,
  goToAfter = '',
  confirmModalType = ''
) => {
  return {
    type: SHOW_CONFIRM_MODAL,
    payload: {isShow, goToAfterConfirm: goToAfter, confirmModalType},
  };
};

export const updateContentSuggUserInput = (userInput) => {
  return {
    type: UPDATE_CONTENT_SUGG_USER_INPUT,
    payload: userInput,
  };
};
export const updateSelectedProduct = (prod) => {
  return {
    type: UPDATE_SELECTED_PRODUCT,
    payload: prod,
  };
};

export const updateSelectedVersion = (version) => {
  return {
    type: UPDATE_SELECTED_VERSION,
    payload: version,
  };
};

export const updateShowProductPicker = (showOrHide) => {
  return {
    type: UPDATE_SHOW_PRODUCT_PICKER,
    payload: showOrHide,
  };
};

export const updateExceptionMsg = (msg) => {
  return {type: UPDATE_EXCEPTION_MSG, payload: msg};
};
export const updateContentSuggLoading = (isLoading) => {
  return {type: UPDATE_CONTENT_SUGG_LOADING, payload: isLoading};
};

export const updateSkillsResponse = (data) => {
  return {type: UPDATE_SKILLS_RESPONSE, payload: data};
};

export const updateResolvedSupportSkill = (skill) => {
  return {type: UPDATE_RESOLVED_SUPP_SKILL, payload: skill};
};

export const toggleUserInput = (showOrHide, newReqId = '') => {
  return {
    type: TOGGLE_USER_INPUT,
    payload: {showOrHide, newReqId},
  };
};

export const toggleMainWindowAndFab = (showOrHide) => {
  return {
    type: TOGGLE_MAIN_WINDOW_AND_FAB,
    payload: showOrHide,
  };
};

export const toggleAvaLoading = (showOrHide) => {
  return {
    type: TOGGLE_AVA_LOADING,
    payload: showOrHide,
  };
};
export const showAvaModal = (backOrRestart) => {
  return {
    type: SHOW_AVA_MODAL,
    payload: backOrRestart,
  };
};
export const closeAvaModal = () => {
  return {
    type: CLOSE_AVA_MODAL,
  };
};

export const disableNavBtns = (bool) => {
  return {
    type: DISABLE_NAVBAR,
    payload: bool,
  };
};

export const failScreen = (bool) => {
  return {
    type: SHOW_FAIL_SCREEN,
    payload: bool,
  };
};

export const togglePopUpMainWindow = (val) => {
  return {
    type: TOGGLE_POP_UP_MAIN_WINDOW,
    payload: val,
  };
};

export const updateOpenUHMThroughLink = (val) => {
  return {
    type: OPEN_UHM_THROUGH_LINK,
    payload: val,
  };
};

export const updateContextualLinkOrigin = (val) => {
  return {
    type: UPDATE_CONTEXTUAL_LINK_ORIGIN,
    payload: val,
  };
};

export const updateLinkLocation = (val) => {
  return {
    type: UPDATE_LINK_LOCATION,
    payload: val,
  };
};

export const updateContactAppLoading = (val) => {
  return {
    type: UPDATE_CONTACT_APP_LOADING,
    payload: val,
  };
};

export const quickToggleShowPhoneFooter = (val) => {
  return {
    type: QUICK_TOGGLE_SHOW_PHONE_FOOTER,
    payload: val,
  };
};

export const toggleShowFeedbackWidgetFlow = (val) => {
  return {
    type: SHOW_FEEDBACK_WIDGET_FLOW,
    payload: val,
  };
};

export const updateFeedbackWidgetMounted = (val) => {
  return {
    type: FEEDBACK_WIDGET_MOUNTED,
    payload: val,
  };
};

export const updateShowAdditionalQuestionsPage = (val) => {
  return {
    type: SHOW_ADDITIONAL_QUESTIONS,
    payload: val,
  };
};

export const updateContainerEventMessage = (val) => {
  return {
    type: CONTAINER_EVENT_MESSAGE,
    payload: val,
  };
};

export const updateUiData = (val) => {
  return {
    type: UPDATE_UI_DATA,
    payload: val,
  };
};
export const resetUiStates = (val) => {
  return {
    type: RESET_UI_STATES,
    payload: val,
  };
};

export const updateResetToHome = (val) => {
  return {
    type: RESET_TO_HOME,
    payload: val,
  };
};

export const updateHeaderAndFabColor = (val) => {
  return {
    type: UPDATE_FAB_HEADER_COLORS,
    payload: val,
  };
};

export const updateIsChatActive = (val) => {
  return {
    type: UPDATE_IS_CHAT_ACTIVE,
    payload: val,
  };
};

export const updateIsEndChatThroughButton = (val) => {
  return {
    type: IS_END_CHAT_THROUGH_BUTTON,
    payload: val,
  };
};

export const updateUhmSubHeaderType = (val) => {
  return {
    type: UPDATE_UHM_SUB_HEADER_TYPE,
    payload: val,
  };
};

export const updateSaveChatTrigger = (val) => {
  return {
    type: UPDATE_SAVE_CHAT_TRIGGER,
    payload: val,
  };
};

export const updateEndChatTrigger = (val) => {
  return {
    type: UPDATE_END_CHAT_TRIGGER,
    payload: val,
  };
};

export const updateShowOverlayComponent = (val) => {
  return {
    type: UPDATE_SHOW_OVERLAY_COMPONENT,
    payload: val,
  };
};

export const updateHasInstructionalText = (val) => {
  return {
    type: HAS_INTRUCTIONAL_TEXT,
    payload: val,
  };
};

export const updateUserInputFromAva = (val) => {
  return {
    type: UPDATE_USER_INPUT_FROM_AVA,
    payload: val,
  };
};

export const updateAnythingElseEndChat = (val) => {
  return {
    type: ANYTHING_ELSE_END_CHAT,
    payload: val,
  };
};

// export const updateShowAgentAvailabilityComponent = (val) => {
//   return {
//     type: SHOW_AGENT_AVAILABILITY_COMPONENT,
//     payload: val,
//   };
// };

export const updateShowAgentAvailabilityFallbackComponent = (val) => {
  return {
    type: SHOW_AGENT_AVAILABILITY_FALLBACK_COMPONENT,
    payload: val,
  };
};

export const updateShowAnythingElseComponent = (val) => {
  return {
    type: SHOW_ANYTHING_ELSE_COMPONENT,
    payload: val,
  };
};

export const updateShowPhoneHourBubbleComponent = (val) => {
  return {
    type: SHOW_PHONE_HOUR_BUBBLE_COMPONENT,
    payload: val,
  };
};

export const updateDeepLinkCAEduFlow = (val) => {
  return {
    type: DEEPLINK_CA_EDU_FLOW,
    payload: val,
  };
};
export const updateUserInteracted = (val) => {
  return {
    type: UPDATE_USER_INTERACTION,
    payload: val,
  };
};
export const updateOpenAferRedirect = (val) => {
  return {
    type: UPDATE_OPEN_AFTER_REDIRECT,
    payload: val,
  };
};
export const updateRequestId = (val) => {
  return {
    type: UPDATE_REQUEST_ID,
    payload: val,
  };
};
